import { AuthSpinner, Col, useQueryString } from '@carafe/components';
import { strings } from '@localisation';
import React, { useEffect, useState } from 'react';
import { Centered } from '@layout';
import { useSignOutMutation } from '@generated/graphql';
import { Routes } from '@routes';
import { useHistory } from 'react-router-dom';

export const SignOut = (): JSX.Element => {
  const history = useHistory();

  const [signedOut, setSignedOut] = useState(false);

  const [customerCode, sandboxManagement, target] = useQueryString([
    'customerCode',
    'sandboxManagement',
    'target',
  ]);

  const [{ fetching: signOutFetching }, executeSignOut] = useSignOutMutation();

  useEffect(() => {
    const waitForSignOut = async () => {
      await executeSignOut({
        customerCode: customerCode ?? '',
        sandboxManagement: sandboxManagement?.toLowerCase() === 'true',
      });
    };
    waitForSignOut().then(() => {
      setSignedOut(true);
    }); //don't care about the return result as that is used for the delete cookie
  }, [customerCode, executeSignOut, sandboxManagement]);

  useEffect(() => {
    if (!signOutFetching && signedOut) {
      const url = new URL(Routes.SignInSignUp, window.location.origin);
      const params = url.searchParams;
      if (customerCode) {
        params.append('customerCode', customerCode);
      }

      if (target) {
        params.append('target', target);
      }

      history.push(url.pathname + url.search);
    }
  }, [customerCode, history, signOutFetching, signedOut, target]);

  return (
    <Centered>
      <Col alignItems="center" maxWidth="21rem">
        <AuthSpinner title={''} description={strings.access.description} />
      </Col>
    </Centered>
  );
};
